import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
    Typography,
    Card,
    Select,
    Form,
    Button,
    Table
} from "antd";
import data from '../../../../../src/config/data/LoanProductFormData.json'


const { Text } = Typography;

export const ChargesForm = (props) => {
    const { chargeDataSource } = props

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Collected on",
            dataIndex: "collectedOn",
        },
    ]

    return (
        <Card
            style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                padding: 10,
            }}
        >
            <Table
                columns={columns}
                dataSource={chargeDataSource}
            />
        </Card>

    );
}
